import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import PointContext from "../../context/point/context";
import PointTable from "../../components/point/point-table";
import PointContextProvider from "../../context/point/provider";
import PointFilter from "../../components/point/point-filter";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import { IExportPointCollection, colomnsExportPointExcel } from "../../models/point/request";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
import { addSearchToURL, getFiltersFromURL, getKeywordFromURL } from "../../utils/helpers/url";
import { debounce } from "lodash";
interface IProps {
  children?: React.ReactNode;
}

const Point: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(getKeywordFromURL());
  const [exportModalVisible, setExportModalVisible] = useState(false);

  const { actions, loading, query } = useContext(PointContext);

  useEffect(() => {
    const filters = getFiltersFromURL();
    actions.setQuery({
      page: 1,
      perPage: 10,
      filters: filters,
      keyword: search
    });
  }, []);

  const debouncedSearch = debounce((value: string | undefined) => {
    addSearchToURL(value);
    actions.setSearch(value);
  }, 300);

  useEffect(() => {
    debouncedSearch(search);
    return () => {
      debouncedSearch.cancel();
    };
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("points")}
        subTitle={t("points_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Button
            type="primary"
            onClick={() => {
              setExportModalVisible(true);
            }}
            icon={<FileExcelOutlined />}
          >
            {t("export_to_excel")}
          </Button>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/points/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_point")}
            </Button>
          </Can>,
        ]}
      />
      <ExportToExcelModal
        id="export-category"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            id: false,
            name: false,
            status: false,
            debtValue: false,
            employ: false,
            city: false,
            area: false,
          } as IExportPointCollection
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          // await a(columnsNames);
          await actions.exportExcel(columnsNames);
          setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel names={colomnsExportPointExcel} />
      </ExportToExcelModal>
      <SearchFilterCard
        formId="point-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete("keyword");
          Object.keys(getFiltersFromURL()).forEach((key) =>
            searchParams.delete(key)
          );
          navigate(`${location.pathname}`, { replace: true });
          actions.setQuery({
            page: 1,
            perPage: query?.perPage,
            keyword: undefined,
            filters: [],
          });
          const form = document.getElementById("point-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <PointFilter />
      </SearchFilterCard>

      {/* <Outlet /> */}
      <PointTable />
    </div>
  );
};

const PointPage = () => {
  return (
    // ContextProvider
    <PointContextProvider>
      <Point />
    </PointContextProvider>
  );
};
export default PointPage;
